/* global window */

import $ from 'jquery'; // eslint-disable-line no-restricted-imports
import {
  user_adfs_omniauth_authorize_path,
  d_users_adfs_statuses_path,
} from 'js-routes/generated/routes';
import sendRequestAsForm from 'helpers/sendRequestAsForm';

export default () => {
  const $userEmail = $('#user_email');
  const $userPassword = $('#user_password');
  const $signInButton = $('#sign_in_button');
  const $adfsButton = $('#adfs_button');

  const getSearchParams = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    return Object.fromEntries(urlSearchParams.entries()) || {};
  };

  // FIXME: change regex after updating validation on User model
  // Add simple email validation to prevent status request for not valid input
  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+$/;
    return regex.test(String(email).toLowerCase());
  };

  const checkAdfsStatus = (success, fail) => () => {
    const email = $userEmail.val();
    if (validateEmail(email)) {
      const params = $.param({ email });
      const failResponse = (data) => {
        console.log('Fail!'); // eslint-disable-line no-console
        console.log(`Received: ${data}`); // eslint-disable-line no-console
      };

      $.ajax(`${d_users_adfs_statuses_path()}?${params}`)
        .then((data) => (data.redirect ? success(data) : fail(data)), failResponse);
    } else {
      fail();
    }
  };

  const performOmniauthRequest = () => {
    const {
      mobile = false,
      email: emailSearchParam,
      tenant: tenantSearchParam,
    } = getSearchParams();

    const email = $userEmail.val() || emailSearchParam;
    const tenant = $adfsButton.data('tenant') || tenantSearchParam;

    if (!email || !tenant) return;

    sendRequestAsForm({
      action: user_adfs_omniauth_authorize_path(),
      method: 'POST',
      sendInNewWindow: false,
      params: { email, tenant, mobile },
    });
  };

  const hidePasswordField = () => $userPassword.addClass('hidden');
  const showPasswordField = () => $userPassword.removeClass('hidden');
  const hideLoginButton = () => $signInButton.addClass('hidden');
  const showLoginButton = () => $signInButton.removeClass('hidden');
  const hideAdfsLoginButton = () => $adfsButton.addClass('hidden');
  const showAdfsLoginButton = () => $adfsButton.removeClass('hidden');

  if ($('.devise-form-login-with-adfs').length) {
    const restoreDefaultInputState = () => {
      $adfsButton.data('tenant', '');
      hideAdfsLoginButton();
      showPasswordField();
      showLoginButton();
    };

    const successResponse = (data) => {
      showAdfsLoginButton();
      $adfsButton.data('tenant', data.tenant);
      $adfsButton.trigger('focus');
      if (data.redirect) {
        performOmniauthRequest();
        hidePasswordField();
        hideLoginButton();
      }
    };

    $userEmail.on('focusin', restoreDefaultInputState);
    $userEmail.on('focusout', checkAdfsStatus(successResponse, restoreDefaultInputState));
    $('#adfs_button').on('click', (e) => {
      performOmniauthRequest();
      e.stopPropagation();
    });
  }

  if ($('.devise-form-adfs').length) {
    const failResponse = () => $adfsButton.data('tenant', '');
    const successResponse = (data) => {
      $adfsButton.data('tenant', data.tenant);
      if (data.redirect) {
        performOmniauthRequest();
      }
    };

    const { checked, email } = getSearchParams();

    if (email && checked === 'true') {
      performOmniauthRequest();
    }

    if (email && (!checked || checked === 'false')) {
      checkAdfsStatus(successResponse, failResponse)();
    }

    $userEmail.on('focusout', checkAdfsStatus(successResponse, failResponse));

    $('#adfs_button').on('click', (e) => {
      checkAdfsStatus(successResponse, failResponse)();
      e.stopPropagation();
    });
  }
};
